const GET_RSU_MOD_LIST = "GET_RSU_MOD_LIST";
const GET_RSU_MOD_SUCCESS = "GET_RSU_MOD_SUCCESS";
const GET_RSU_MOD_FAILURE = "GET_RSU_MOD_FAILURE";
const SET_DATE_TIME_ORDER = "SET_DATE_TIME_ORDER";
const SET_MOD_PAUSE_ACTION = "SET_MOD_PAUSE_ACTION";
const SET_MOD_PAUSE_ACTION_SUCCESS = "SET_MOD_PAUSE_ACTION_SUCCESS";
const SET_MOD_PAUSE_ACTION_FAILURE = "SET_MOD_PAUSE_ACTION_FAILURE";
const SET_MOD_RESUME_ACTION = "SET_MOD_RESUME_ACTION";
const SET_MOD_RESUME_ACTION_SUCCESS = "SET_MOD_RESUME_ACTION_SUCCESS";
const SET_MOD_RESUME_ACTION_FAILURE = "SET_MOD_RESUME_ACTION_FAILURE";
const SHOW_RESUME_CONFIRMATION = "SHOW_RESUME_CONFIRMATION";
const HIDE_RESUME_CONFIRMATION = "HIDE_RESUME_CONFIRMATION";
const FILTERED_MOD_LIST = "FILTERED_MOD_LIST";

const RSUJOB_PAUSE_REQUESTED = "PauseRequested";
const RSUJOB_RESUME_REQUESTED = "ResumeRequested";
const PAUSE_ACTION_IN_PROGRESS = "PauseActionInProgress";
const RESUME_ACTION_IN_PROGRESS = "ResumeActionInProgress";
const MOD_CREATED = "MODCreated";
const RSUJOB_PAUSE_COMMAND = "pause";
const RSUJOB_RESUME_COMMAND = "resume";
const RSUJOB_PAUSE_SUCCESS = "Success";
const RSUJOB_RESUME_SUCCESS = "Success";



const RESUME_CONFIRMATION_MESSAGE = "Are you sure you want to Resume the Mod ";
const RESUME_CONFIRMATION_TITLE = "Resume Confirmation";


export {
    GET_RSU_MOD_LIST,
    GET_RSU_MOD_SUCCESS,
    GET_RSU_MOD_FAILURE,
    SET_DATE_TIME_ORDER,
    SET_MOD_PAUSE_ACTION,
    SET_MOD_PAUSE_ACTION_SUCCESS,
    SET_MOD_PAUSE_ACTION_FAILURE,
    SET_MOD_RESUME_ACTION,
    SET_MOD_RESUME_ACTION_SUCCESS,
    SET_MOD_RESUME_ACTION_FAILURE,
    RSUJOB_PAUSE_REQUESTED,
    RSUJOB_RESUME_REQUESTED,
    PAUSE_ACTION_IN_PROGRESS,
    RESUME_ACTION_IN_PROGRESS,
    MOD_CREATED,
    RSUJOB_PAUSE_COMMAND,
    RSUJOB_RESUME_COMMAND,
    RSUJOB_PAUSE_SUCCESS,
    RSUJOB_RESUME_SUCCESS,
    SHOW_RESUME_CONFIRMATION,
    HIDE_RESUME_CONFIRMATION,
    RESUME_CONFIRMATION_MESSAGE,
    RESUME_CONFIRMATION_TITLE,
    FILTERED_MOD_LIST
}